import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  buttonIsDropdown?: boolean;
  competencyProfileId: number;
  onRemove: () => Promise<void>;
}

const CompetencyProfilesRemove = ({
  buttonIsDropdown = true,
  competencyProfileId,
  onRemove
}: Props) => {
  const {
    messages,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const handleConfirm = async (values?: { deletionReason?: string }) => {
    let url = `/admin/competency-profiles/${competencyProfileId}`;

    if (values?.deletionReason) {
      const params = new URLSearchParams({
        deletionReason: values.deletionReason
      });
      url += `?${params.toString()}`;
    }

    await api.delete(url);
    await onRemove();
    return true;
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={buttonIsDropdown}
      buttonText={messages.competencyProfilesRemove}
      confirmText={messages.competencyProfilesRemoveConfirm}
      confirmTitle={messages.competencyProfilesRemove}
      id={`deletionReasonCompetencyProfile-${competencyProfileId}`}
      onConfirm={handleConfirm}
      successMessage={messages.competencyProfilesRemoveSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={buttonIsDropdown}
      buttonText={messages.competencyProfilesRemove}
      category="danger"
      confirmText={messages.competencyProfilesRemoveConfirm}
      confirmTitle={messages.competencyProfilesRemove}
      onConfirm={handleConfirm}
      successMessage={messages.competencyProfilesRemoveSuccess}
    />
  );
};

export default CompetencyProfilesRemove;
